export default class YieldInsight {
  date: string;
  lackingYield;
  actualYield;
  predictedYield;
  meterStatus;

  constructor(
    date: string,
    lackingYield,
    actualYield,
    predictedYield,
    meterStatus,
  ) {
    this.date = date;
    this.lackingYield = lackingYield;
    this.actualYield = actualYield;
    this.predictedYield = predictedYield;
    this.meterStatus = meterStatus;
  }
}
